module.exports = __webpack_public_path__ + "img/logo.d67b818b.svg";